import { render, staticRenderFns } from "./SentSummaryTo.vue?vue&type=template&id=dd899302&scoped=true&"
import script from "./SentSummaryTo.vue?vue&type=script&lang=js&"
export * from "./SentSummaryTo.vue?vue&type=script&lang=js&"
import style0 from "./SentSummaryTo.vue?vue&type=style&index=0&id=dd899302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd899302",
  null
  
)

export default component.exports